import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../common/SEO/SEO";

const NotFoundPage = () => {
  return (
    <main
      style={{
        minHeight: "70vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "4rem 1.5rem",
        textAlign: "center",
        backgroundColor: "#fff",
      }}
    >
      <SEO
        title="Page Not Found (404)"
        description="The page you are looking for does not exist or has been moved. Explore Maya Wears latest contemporary clothing collections."
        noindex={true}
      />
      <span
        style={{
          fontSize: "0.85rem",
          letterSpacing: "0.25em",
          textTransform: "uppercase",
          color: "#888",
          marginBottom: "1rem",
        }}
      >
        Error 404
      </span>
      <h1
        style={{
          fontSize: "clamp(2rem, 5vw, 3.5rem)",
          fontWeight: 600,
          letterSpacing: "-0.02em",
          color: "#111",
          margin: "0 0 1.25rem 0",
          fontFamily: "inherit",
        }}
      >
        Page Not Found
      </h1>
      <p
        style={{
          maxWidth: "480px",
          color: "#666",
          fontSize: "1rem",
          lineHeight: "1.6",
          margin: "0 auto 2.5rem auto",
        }}
      >
        The silhouette you are seeking could not be found or has moved to our archive. Explore our latest drops and signature pieces.
      </p>
      <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", justifyContent: "center" }}>
        <Link
          to="/"
          style={{
            display: "inline-block",
            padding: "0.85rem 2rem",
            backgroundColor: "#000",
            color: "#fff",
            textDecoration: "none",
            fontSize: "0.85rem",
            fontWeight: 500,
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            borderRadius: "2px",
          }}
        >
          Return Home
        </Link>
        <Link
          to="/all_product"
          style={{
            display: "inline-block",
            padding: "0.85rem 2rem",
            backgroundColor: "#f5f5f5",
            color: "#111",
            textDecoration: "none",
            fontSize: "0.85rem",
            fontWeight: 500,
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            borderRadius: "2px",
            border: "1px solid #ddd",
          }}
        >
          Explore All Products
        </Link>
      </div>
    </main>
  );
};

export default NotFoundPage;
